export * from './lib/components/add/add.component';
export * from './lib/core-ui-table-actions.module';
export type { RodaPe, IDescontoRodape, DescontoPrefix } from './lib/components/desconto/models/desconto.models';
